export enum PersonalProtectiveEquipmentSituationType {
    // 1 - VÃ¡lido
    VALID = 'VALID',
    // 2 - A vencer
    EXPIRING_SOON = 'EXPIRING_SOON',
    // 3 - Expirado
    EXPIRED = 'EXPIRED'
}
